import axios from 'axios'
import md5 from 'md5'
import store from '@/store/index'
import { getParameterValue } from '@/services/commonFunction'

const genUUID = (): string => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
    const r = (Math.random() * 16) | 0
    return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16)
  })
}

// 方德PC 签名 fixed 值
const FIXED = 'a4f9c2d87b3e4f16a9d08c5b2e7f1c43'

const sortJoinParams = (params: Record<string, any> | null | undefined): string => {
  if (!params) return ''
  return Object.keys(params).sort().map(key => params[key]).join('')
}

const createSign = (config: any): { signature: string; timestamp: number } => {
  const timestamp = Date.now()
  const { method, headers } = config
  const params = config.data || config.params
  let body = ''

  if (method?.toLowerCase() === 'post') {
    const contentType: string = headers['Content-Type'] || headers['content-type'] || ''
    if (contentType.includes('application/x-www-form-urlencoded')) {
      body = sortJoinParams(params)
    } else {
      // application/json
      body = JSON.stringify(params || '')
    }
  } else {
    // GET
    body = sortJoinParams(params)
  }

  const signature = md5(FIXED + body + timestamp)
  return { signature, timestamp }
}

const service = axios.create({
  timeout: 60000,
  withCredentials: false,
  headers: {
    'Content-Type': 'application/json;charset=UTF-8'
  }
})

service.interceptors.request.use(
  (config: any) => {
    config.headers['Content-Type'] = config.headers['Content-Type'] || 'application/json;charset=UTF-8'

    // 签名
    const { signature, timestamp } = createSign(config)
    config.headers['appcode'] = 'com.fdzq.pc'
    config.headers['requestId'] = genUUID()
    config.headers['timestamp'] = timestamp
    config.headers['signature'] = signature

    // token - hash 模式下从 # 后的 query 参数获取
    const hashSearch = window.location.hash.includes('?') ? window.location.hash.split('?')[1] : ''
    const token = new URLSearchParams(hashSearch).get('token') || ''
    if (token) {
      config.headers['fdzqToken'] = token
      config.headers['token'] = token
    }

    return config
  },
  (error: any) => Promise.reject(error)
)

service.interceptors.response.use(
  (response: any) => Promise.resolve(response.data),
  (error: any) => {
    console.error('[requestInfoFD]', error)
    return Promise.reject(error)
  }
)

export default service
